import {
  takeEvery,
  takeLatest,
  takeLeading,
  select,
  put,
} from 'redux-saga/effects'

import {
  setDirty,
  removeDirty,
  resetDirty,
  resetErrors,
} from 'actions/validation'
import {
  UPDATE_FRAGMENT_VALUE,
  UPDATE_FRAGMENTS,
  POWER_TAKE_OFF_RECEIVED,
  CLEAR_POWER_TAKE_OFF,
  UPDATE_FRAGMENTS_SUCCESS,
  RESET_FRAGMENTS,
  postUpdateFragments,
} from 'actions/powerTakeOff'
import { fragmentSchema } from 'schemas/validation/fragment' // TODO: name powerTakeOff ?
import { getFragment, getDirtyFragments } from 'selectors/powerTakeOff'
import { getVehicleRouteMatch } from 'selectors/router'
import {
  NOTIFICATION_INFO,
  PTO_TEMPLATE,
  PTO_TEMPLATE_EDIT_NOTIFY,
} from 'utils/constants'
import {
  createSystemNotification,
  deleteSystemNotification,
} from 'actions/application'
import strings from 'utils/strings'
import { SET_IS_EDITING } from 'actions/navigator'
import { validate, startErrorWatching } from './validation'

function* validateFragment(schema, action) {
  const { id } = action
  const fragment = yield select((state) => getFragment(state, { id }))
  // *** removed upper and lower bound values for task 42157 ***
  const {
    configuration: { value, originalValue },
  } = fragment

  // check if dirty or not
  // TODO: extract somewhere?
  if (value === originalValue) {
    yield put(removeDirty(id))
  } else {
    yield put(setDirty(id))
  }
  // *** Per task 42157 Turning off boundary validations until better design ***
  // if (lowerBound || upperBound) {
  //   const { lowerBoundMax, upperBoundMin } = yield select((state) =>
  //     getGroupBoundaries(state, { lowerBound, upperBound })
  //   )

  //   yield validate(schema, fragment, id, {
  //     lowerBoundMax,
  //     upperBoundMin,
  //   })
  // } else {
  // *** Per task 42157 Turning off boundary validations until better design ***
  yield validate(schema, fragment, id)
  // }
}

function* watchUpdateFragment() {
  yield takeLatest([UPDATE_FRAGMENT_VALUE], validateFragment, fragmentSchema)
}

export function* watchPowerTakeOffValidation() {
  yield startErrorWatching({
    actionTypes: {
      activate: POWER_TAKE_OFF_RECEIVED,
      abort: CLEAR_POWER_TAKE_OFF,
    },
    handlers: [watchUpdateFragment],
    perpetual: true,
  })
}

export function* watchUpdateFragments() {
  yield takeLeading(UPDATE_FRAGMENTS, submitFragments)
}

function* submitFragments(action) {
  const fragments = yield select(getDirtyFragments)
  const {
    params: { id: serialNumber },
  } = yield select(getVehicleRouteMatch)
  const { notes, callback } = action

  yield put(postUpdateFragments(serialNumber, fragments, notes, callback))
}

// TODO: incorporate into whole validation workflow
export function* watchFragmentUpdateSuccess() {
  yield takeEvery(
    [UPDATE_FRAGMENTS_SUCCESS, RESET_FRAGMENTS, CLEAR_POWER_TAKE_OFF],
    resetDirtyFields
  )
}

function* resetDirtyFields() {
  yield put(resetDirty())
  yield put(resetErrors())
}

export function* watchIsEditingPtoTemplate() {
  yield takeEvery(SET_IS_EDITING, handlePtoTemplateEditingNotification)
}

export function* handlePtoTemplateEditingNotification(action) {
  const { isEditing, entity } = action
  if (entity !== PTO_TEMPLATE) return

  const bannerInfo = {
    notificationMessage: strings.editing_pto_template,
    notificationType: NOTIFICATION_INFO,
    notificationId: PTO_TEMPLATE_EDIT_NOTIFY,
    persistent: true,
  }

  if (isEditing) {
    yield put(createSystemNotification(bannerInfo))
  } else {
    const { notificationId } = bannerInfo
    yield put(deleteSystemNotification({ notificationId }))
  }
}
